import React from "react";
import { ImageMap } from "@qiuz/react-image-map";

export const ImageMapModule = (props) => {
  const img = "https://jirangopub.s3.eu-north-1.amazonaws.com/Files/902/MonopolSpelplan3.png";
  const { clientKey } = props;
  const { url, data, target } = props.settings;
  const mapArea = [
    { width: "8%", height: "14.389799635701275%", left: "69.06538469363481%", top: "2.0036429872495445%", href: "https://google.se" },
    { width: "8.205128205128204%", height: "7.285974499089254%", left: "68.86025648850661%", top: "38.97996357012751%", href: "https://aftonbladet.se" },
  ];

  const onMapClick = (area, index) => {
    const link = area.href
      .toString()
      .replace(/\[clientkey\]/gi, clientKey)
      .replace(/\[badgeno\]/gi, clientKey);
    window.open(link, target);
  };


  // in hooks
  const ImageMapComponent = React.useMemo(() => <ImageMap className="usage-map" src={url} map={data ? JSON.parse(data) : []} onMapClick={onMapClick} />, [data, url,target]);

  return <div style={{ overflowY: "auto", maxHeight: "100vh" }}>{ImageMapComponent}</div>;
};
